export const UPLOAD_TIMEOUT = "upload_timeout";
export const ENGINE_TIMEOUT = "engine_timeout";
export const OUT_OF_CONVERSION_MINUTES = "out_of_conversion_minutes";
export const DAILY_OPERATIONS_LIMIT_EXCEEDS = "daily_operations_limit_exceeds";
export const OUT_OF_CONVERSION_MINUTES_PER_TASK = "out_of_conversion_minutes_per_task";
export const USER_DELETED_TASK = "user_deleted_task";
export const INSUFFICIENT_PERMISSION = 'insufficient_permission';
export const INVALID_CREDENTIALS = 'invalid_credentials';
export const STORAGE_QUOTA_EXCEEDED = 'storage_quota_exceeded'
export const DRM_PROTECTED_FILE = "drm_protected_file";
